import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { AdminOverview } from '../Components/Organisms/AdminOverview/AdminOverview'

/**
 * Routed Administration overview page.
 */
@Route(RouteID.ADMIN)
export class AdminOverviewPage extends Component {
    /**
     * Renders the guarded routed Administration overview page.
     *
     * @returns Administration overview page tree.
     */
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.ADMIN}>
                    <LanguageContextProvider>
                    <AdminOverview />
                    </LanguageContextProvider>
            </RouteGuard>
        )
    }
}
